import { Translations } from '@typings';
import { createAction } from 'typesafe-actions';

export const setModifiedLanguages = createAction('cms/SET_MODIFIED_LANGUAGES')<Translations.SupportedLanguagesCodes[]>();
export const setHasUnsavedLayoutChanges = createAction('cms/SET_HAS_LAYOUT_CHANGES')<boolean>();
